import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirConditionIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirConditionIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.3218 14.4979H3.6785C2.81133 14.4979 2.10596 13.7925 2.10596 12.9257V7.87399C2.10596 7.00712 2.81133 6.30176 3.6785 6.30176H20.3218C21.1887 6.30176 21.894 7.00713 21.894 7.87399V12.9257C21.894 13.7925 21.1887 14.4979 20.3218 14.4979ZM3.6785 7.24676C3.33243 7.24676 3.05096 7.52823 3.05096 7.87399V12.9257C3.05096 13.2714 3.33243 13.5529 3.6785 13.5529H20.3218C20.6676 13.5529 20.949 13.2714 20.949 12.9257V7.87399C20.949 7.52823 20.6676 7.24676 20.3218 7.24676H3.6785Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.7653 14.4979H5.23474C5.09724 14.4979 4.96681 14.4382 4.87698 14.3339C4.78716 14.23 4.74717 14.0922 4.76747 13.9562L5.04433 12.0877C5.07848 11.8561 5.2775 11.6844 5.5116 11.6844H18.4887C18.7228 11.6844 18.9219 11.8561 18.956 12.0877L19.2326 13.9562C19.2529 14.0922 19.2129 14.23 19.123 14.3339C19.0332 14.4382 18.9028 14.4979 18.7653 14.4979ZM5.7823 13.5529H18.2177L18.0811 12.6294H5.91919L5.7823 13.5529Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0873 9.0252C17.7393 9.0252 17.4561 9.30839 17.4561 9.65644C17.4561 10.0045 17.7393 10.2877 18.0873 10.2877C18.4354 10.2877 18.7186 10.0045 18.7186 9.65644C18.7186 9.30839 18.4354 9.0252 18.0873 9.0252Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.52784 17.6993C9.3648 17.6993 9.20576 17.6147 9.1184 17.463L8.39519 16.2104C8.26476 15.9843 8.34197 15.6955 8.56807 15.565C8.79386 15.434 9.08302 15.5115 9.21345 15.7379L9.93666 16.9905C10.0671 17.2166 9.98988 17.5055 9.76378 17.6359C9.68934 17.679 9.60813 17.6993 9.52784 17.6993Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.3619 17.6993C12.1989 17.6993 12.0398 17.6147 11.9525 17.463L11.2293 16.2104C11.0988 15.9843 11.176 15.6955 11.4021 15.565C11.6282 15.434 11.9171 15.5115 12.0475 15.7379L12.7707 16.9905C12.9012 17.2166 12.824 17.5055 12.5979 17.6359C12.5234 17.679 12.4422 17.6993 12.3619 17.6993Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.1963 17.6993C15.0333 17.6993 14.8742 17.6147 14.7869 17.463L14.0637 16.2104C13.9332 15.9843 14.0104 15.6955 14.2365 15.565C14.4623 15.434 14.7515 15.5115 14.8819 15.7379L15.6051 16.9905C15.7356 17.2166 15.6583 17.5055 15.4322 17.6359C15.3578 17.679 15.2766 17.6993 15.1963 17.6993Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AirConditionIcon;
